import React, { useState } from 'react'
import { Data } from './Dashboardarray'
import Form from 'react-bootstrap/Form';
import fb from "../assets/fb.png"
import Directories from './Directories';

function Dashboardfooter() {
  const [state, setstate] = useState(Data)
  console.log(state, "state")
  return (<>
    <div className='row mt-2'>
      <div className='col-xl-4 col-lg-6 col-md-12'>
        <p className='label1'>9- Business working days and hours</p>
        {state.map((value, index) => {
          return (
            <div className='d-flex align-items-center justify-content-between' style={{ overflow: 'hidden' }} key={index}>
              <div className='day_div'>
                <p className='day'>{value.day}</p>
                <div >
                  <p className='status'>{value.status1}</p>
                  <p className='status1'>{value.status2}</p>
                </div>

              </div>
              <div className='d-flex align-items-center justify-content-between seconed_main'>
                <div className='day2_div'>
                  <div>
                    <p className='times'>{value.time}</p>
                    <div className='hour_div'>
                      <p>00:00</p>
                    </div>
                  </div>

                  <div >
                    <p className='mode'>{value.mode1}</p>
                    <p className='mode1'>{value.mode2}</p>
                  </div>
                </div>
                <p className='mt-4'>-</p>
                <div className='day2_div'>
                  <p className='times'>{value.time2}</p>
                  <div >
                    <p className='mode'>{value.mode1}</p>
                    <p className='mode1'>{value.mode2}</p>
                  </div>
                </div>
              </div>
            </div>)
        })}
      </div>
      <div className='col-xl-4 col-lg-6 col-md-12'>
        <p className='label1'>10- Business Description</p>
        <div style={{ position: "relative" }}>
          <textarea className='textarea' placeholder='Description...'>
          </textarea>
          <p className='numbering'>10<span className='text'>/750</span></p>
        </div>
      </div>
      <div className='col-xl-4 col-lg-6 col-md-12 mt-3'>
        <Directories/>
      </div>
    </div>
    <div className='d-flex justify-content-center mt-5'>
      <button className='update_btn'>Update</button>
    </div>
  </>

  )
}

export default Dashboardfooter